module.exports = __webpack_public_path__ + "static/media/bg-3-relax.abc21c1d.svg";